/**
 * ADR-017 Fase 4 — stub de heal cash session.
 *
 * La cola offline fue eliminada. No hay failed items que escanear ni
 * remapear. Las funciones de clasificación de errores siguen vivas
 * (las usan repairCashOutflowCashSession, repairExpenseSettlementCashSession,
 * cashSessionsRepo). Este módulo las re-exporta y devuelve zeros.
 */
import {
  isCashSessionAlreadyOpenError,
  isCashSessionNotOpenError,
  isSaleCashSessionFkError,
} from './cashSessionHealErrors';

export { isCashSessionAlreadyOpenError, isCashSessionNotOpenError, isSaleCashSessionFkError };

export async function healCashSessionAlreadyOpenConflicts(): Promise<{
  healedOpens: number;
  remapped: number;
  healedSales: number;
  healedOutflows: number;
}> {
  return { healedOpens: 0, remapped: 0, healedSales: 0, healedOutflows: 0 };
}
